module.exports = __webpack_public_path__ + "static/phantasya-ffe5f4fae59c87482db3dab600b85c2c.jpg";